<template>
  <b-modal
    ref="modal"
    :cancel-variant="data.cancelVariant || undefined"
    :header-bg-variant="data.headerBgVariant || undefined"
    :footer-bg-variant="data.footerBgVariant || undefined"
    :header-text-variant="data.headerTextVariant || undefined"
    :size="data.size || 'md'"
    :centered="data.centered || undefined"
    :scrollable="data.scrollable || undefined"
    :no-close-on-backdrop="data.noCloseOnBackdrop || undefined"
    :no-close-on-esc="data.noCloseOnEsc || undefined"
    :hide-header-close="data.hideHeaderClose || undefined"

    :title-html="data.title"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
    @ok="close(1)"
    @cancel="close()"
  >
    <template v-slot:modal-header-close>
      <b-button
        size="sm"
        variant="primary"
        class="ni ni-close"
        @click="close()"
      >
      </b-button>
    </template>
    <p
      class="my-4"
      v-html="data.body"
    ></p>

    <template #modal-footer>
      <div class="w-100 d-flex">
        <b-button
          variant="info"
          size="sm"
          @click="close()"
          v-text="data.cancelTitle || _trans('Cancel')"
        >
        </b-button>
        <b-button
          class="ml-auto mr-1"
          variant="info"
          size="sm"
          @click="close(0)"
          v-text="data.noTitle || _trans('No')"
        >
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="close(1)"
          v-text="data.okTitle || _trans('Ok')"
        >
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import modal from "@dialogs/modal.vue";
export default {
    mixins: [modal]
}
</script>



// WEBPACK FOOTER //
// src/app/dialogs/modalYesNo.vue